import { fetchApi } from '@/config/axiosSetting';
import {
  ExpertEntryTabsQueryResponseType,
  ExpertEntryTabsTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQuery.type';

export const getInitialVisitExpertTabsQueryFunction = (
  params: ExpertEntryTabsTypeParams,
): Promise<ExpertEntryTabsQueryResponseType[]> => {
  return fetchApi.get(`/initial/reports/${params.id}/adjusting/entry_tabs/`, {
    params: {
      id: params.id,
    },
  });
};
